import { ListOrdered } from '@chain-zen/ui'

interface RefNumberDisplayProps {
  referenceNumber: string
}

/**
 * Display component for showing reference number as a badge
 */
export const RefNumberDisplay = ({ referenceNumber }: RefNumberDisplayProps) => {
  if (!referenceNumber) return null

  return (
    <div className="flex items-start gap-2 rounded-md bg-background p-2">
      <ListOrdered className="mt-0.5 h-3.5 w-3.5 shrink-0 text-muted-foreground" />
      <p className="text-xs leading-relaxed text-muted-foreground">
        <span className="font-medium text-muted-foreground">Reference:</span> {referenceNumber}
      </p>
    </div>
  )
}
